<script setup>
import { ref, onMounted, computed } from 'vue'
import Main from './Main.vue'
import { Icon, Editable, ProfilePicture } from '@components'

import { useCustomizer } from '@store/customizer'
const $customizer = useCustomizer()

import { useDeviceLayout } from '../useDeviceLayout'
const $deviceLayout = useDeviceLayout()

import { useStaff } from '@store/staff.js'
const $staff = useStaff()

import { useSettings } from '@store/settings'
const $settings = useSettings()

const pageDetails = ref({
    layoutTitle: `${$settings.labels.staff?.singular}`,
    // frontendTitle: 'Select Staff'
})

onMounted(() => {
    $staff.fetchData()
})

const randomStaff = ref({
    staff_id: 'random',
    name: "Any Staff",
    first_name: "Any",
    last_name: "Staff",
    profile_image_url: "",
    cover_images: [],
    thumbnail_image_url: "",
    bio: "",
    highlights: "",
    title: "",
    color: "#875BF7"
})

const staffs = computed(() => {
    return [
        // randomStaff.value,
        ...$staff.getStaffs.filter(staff => staff.meta.status === 'publish' && !staff.meta.is_private)
    ]
})
</script>

<template>
    <Main :pageTitle="pageDetails.layoutTitle" @submit="$customizer.publish" :previous="{ name: 'customizer.form.service' }" :next="{ name: 'customizer.form.date' }">
        <Editable v-model="customizer.staff.title" :iconVisibility="false" border inputClass="text-xl" :inputStyle="$customizer.titleStyle"></Editable>

        <div v-if="$customizer.getMenuStatusById('staff', 'layout_type') === 'grid04'" class="grid gap-4 mt-5" :class="{ 'grid-cols-4': $deviceLayout.isDesktop }, { 'grid-cols-3': $deviceLayout.isTablet }, { 'grid-cols-2': $deviceLayout.isMobile }">
            <div v-for="staff in staffs" :key="staff.staff_id" class="w-full" :class="{ 'border border-[#eaecf0] hover:shadow pl-3 pr-4 py-3': !$customizer.getMenuStatusById('staff', 'show_image') }, { 'rounded-lg': $customizer.isRounded && !$customizer.getMenuStatusById('staff', 'show_image') }">
                <div class="group relative overflow-hidden mb-3" v-if="$customizer.getMenuStatusById('staff', 'show_image')">
                    <ProfilePicture :name="staff?.name" :img="staff?.meta?.profile_image_url" :bgColor="staff?.meta?.color" class="w-full h-[128px]" :imgClass="`${$customizer.isRounded ? '!rounded-lg' : '!rounded-none'}`" :textClass="`${$customizer.isRounded ? '!rounded-lg' : '!rounded-none'}`" />
                    <div v-if="$customizer.getMenuStatusById('staff', 'show_details')" class="group-hover:bottom-0 absolute bottom-[-30px] transition-[0.2s] w-full text-sm leading-5 font-medium text-center bg-[#f9f5ff] text-[#6941c6] underline px-3.5 py-1 left-0" :class="{ '!rounded-b-lg': $customizer.isRounded }">Details</div>
                </div>
                <div class="text-[#101828] text-sm font-semibold truncate" :style="$customizer.subtitleStyle">{{ staff?.name }}</div>
            </div>
        </div>

        <div v-if="$customizer.getMenuStatusById('staff', 'layout_type') === 'grid01'" class="grid gap-4 mt-5" :class="[$deviceLayout.isDesktop ? 'grid-cols-3' : 'grid-cols-2']">
            <div v-for="staff in staffs" :key="staff.staff_id" class="w-full" :class="{ 'border border-[#eaecf0] hover:shadow pl-3 pr-4 py-3': !$customizer.getMenuStatusById('staff', 'show_image') }, { 'rounded-lg': $customizer.isRounded && !$customizer.getMenuStatusById('staff', 'show_image') }">
                <div class="group relative overflow-hidden mb-3" v-if="$customizer.getMenuStatusById('staff', 'show_image')">
                    <ProfilePicture :name="staff?.name" :img="staff?.meta?.profile_image_url" :bgColor="staff?.meta?.color" class="w-full h-[176px]" :imgClass="`${$customizer.isRounded ? '!rounded-lg' : '!rounded-none'}`" :textClass="`${$customizer.isRounded ? '!rounded-lg' : '!rounded-none'}`" />
                    <div v-if="$customizer.getMenuStatusById('staff', 'show_details')" class="group-hover:bottom-0 absolute bottom-[-30px] transition-[0.2s] w-full text-sm leading-5 font-medium text-center bg-[#f9f5ff] text-[#6941c6] underline px-3.5 py-1 left-0" :class="{ '!rounded-b-lg': $customizer.isRounded }">Details</div>
                </div>
                <div class="text-[#101828] text-sm font-semibold truncate" :style="$customizer.subtitleStyle">{{ staff?.name }}</div>
            </div>
        </div>
    </Main>
</template>
